import { combineReducers } from 'redux';
import { reducer as FormReducer } from 'redux-form';

import AssinaturaReducer from './modules/assinatura';
import ConfiguracoesReducer from './modules/configuracoes';
import EnderecosReducer from './modules/enderecos';
import FlowReducer from './modules/flow';
import FormularioReducer from './modules/formularios';
import ModalReducer from './modules/modal';
import ServicosReducer from './modules/servicos';
import SolicitacoesReducer from './modules/solicitacoes';
import UsuarioReducer from './modules/usuario';
import UsuarioLinkReducer from './modules/linkUser/reducer';
import UsuarioPerfilReducer from './modules/perfilUsuario/reducer';
import VisitanteReducer from './modules/visitante';
import NotificationsBadgeReducer from '../App/AppLayout/containers/NotificationBadge/store/reducer';
import NotificationsReducer from '../App/Notifications/store/reducer';
import ItensMenuReducer from './modules/itemMenu';

const rootReducer = combineReducers({
	assinatura: AssinaturaReducer,
	configuracoes: ConfiguracoesReducer,
	enderecos: EnderecosReducer,
	flow: FlowReducer,
	form: FormReducer,
	formularios: FormularioReducer,
	modal: ModalReducer,
	servicos: ServicosReducer,
	solicitacoes: SolicitacoesReducer,
	usuario: UsuarioReducer,
	usuarioLink: UsuarioLinkReducer,
	visitante: VisitanteReducer,
	notificationsBadge: NotificationsBadgeReducer,
	notifications: NotificationsReducer,
	itensMenu: ItensMenuReducer,
	perfilUsuario: UsuarioPerfilReducer
});

export default rootReducer;
